import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { CreateCommunityFeedItemDto, CommunityFeedItemDto } from 'src/Services/API/generated';

export const useCreateCommunityFeedItem = (
  options?: UseMutationOptions<CommunityFeedItemDto, unknown, CreateCommunityFeedItemDto>
) => {
  const queryClient = useQueryClient();

  return useMutation<CommunityFeedItemDto, unknown, CreateCommunityFeedItemDto>(
    'create-community-feed-item',
    async (data: CreateCommunityFeedItemDto) => {
      const response = await communityFeedApi.communityFeedControllerCreateFeedItem(data);

      return response.data;
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(['community-feed']);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
